interface GeoInfoDma {
  callSignId?: string;
  dmaId?: string;
  dmaMarket?: string;
  [key: string]: unknown;
}

interface GeoInfoResponse {
  dmaId: string;
  country: string;
  region: string;
  city: string;
  clientIp: string;
  dmaGroup: string;
  dmaDaiOptIn: string;
  dmaMarket: string;
  dmas?: GeoInfoDma[];
}

export interface ParsedGeoInfo {
  dmas?: GeoInfoDma[];
  stations: (string | undefined)[];
  ipAddress: string;
  city: string;
  region: string;
  country: string;
  dma: string;
  dmaMarket?: string;
}

export const parseGeoInfo = (response: GeoInfoResponse): ParsedGeoInfo => {
  const dmas = response.dmas || [];

  return {
    dmas: response.dmas,
    stations: dmas.map(({ callSignId }) => callSignId),
    ipAddress: response.clientIp,
    city: response.city,
    region: response.region,
    country: response.country,
    dma: response.dmaId,
    // dmaMarket may arrive at the top level (geo v1 shape) or on the dmas[]
    // entries (geo v2) — accept either.
    dmaMarket: response.dmaMarket ?? dmas.map(dma => dma.dmaMarket).find(value => value != null),
  };
};
